//sorting functions ...

import { logToServer } from "./logger";

//...for "My Checklist" & "My Tasks" Obligations
export const sortAssessorObligations = obligations => {
  console.group("SORTER LOGS -- DEBUG");
  // console.trace();

  // const copyOfObligations = JSON.parse(JSON.stringify(obligations)); //deep clone obligations - no need
  const today = new Date().toISOString();
  console.debug({ today });
  const expired = Array.isArray(obligations)
    ? obligations
        .filter(o => {
          return o?.dueDate && o?.dueDate < today;
        })
        .sort((a, b) => {
          const dueA = a.dueDate.toUpperCase(); // ignore upper and lowercase
          const dueB = b.dueDate.toUpperCase(); // ignore upper and lowercase
          if (dueA < dueB) {
            return -1;
          }
          if (dueA > dueB) {
            return 1;
          }
          return 0;
        })
    : [];
  const nonExpired = Array.isArray(obligations)
    ? obligations
        .filter(o => o?.dueDate && o?.dueDate >= today)
        .sort((a, b) => {
          const dueA = a.dueDate.toUpperCase(); // ignore upper and lowercase
          const dueB = b.dueDate.toUpperCase(); // ignore upper and lowercase
          if (dueA < dueB) {
            return -1;
          }
          if (dueA > dueB) {
            return 1;
          }
          return 0;
        })
    : [];
  const noDate = Array.isArray(obligations)
    ? obligations.filter(o => o?.dueDate == null)
    : [];
  const exp1 = [];
  const exp2 = [];
  const exp3 = [];
  const exp4 = [];
  const nonexp1 = [];
  const nonexp2 = [];
  const nonexp3 = [];
  const nonexp4 = [];
  const nodue1 = [];
  const nodue2 = [];
  const nodue3 = [];
  const nodue4 = [];

  console.debug("SORTER", { expired }, { nonExpired }, { noDate });
  //first of all should be all the Expired-Unassigned-Pending-'Everything but Compliant' [exp1]
  for (let o of expired) {
    if (
      o.user_id === "0" &&
      o.action === "Pending" &&
      o.assessment !== "Compliant"
    ) {
      exp1.push(o);
    }
    //then the Expired-'No matter the assign status'-Comlpleted-'Everything but Compliant'  [exp2]
    //what is left of the Expired: assigned-pending-all [exp3], all the compliant [exp4] that will be added in the end
    else if (o.action === "Completed" && o.assessment !== "Compliant") {
      exp2.push(o);
    } else if (o.action === "Pending" && o.assessment !== "Compliant") {
      exp3.push(o);
    } else {
      exp4.push(o);
    }
  }

  //then should be all the nonExpired-Unassigned-Pending-'Everything but Compliant'
  for (let o of nonExpired) {
    if (
      o.user_id === "0" &&
      o.action === "Pending" &&
      o.assessment !== "Compliant"
    ) {
      nonexp1.push(o);
    }
    //then the nonExpired asc-'No matter the assign status'-Comlpleted-'Everything but Compliant'
    //what is left of the nonExpired: assigned-pending-all [nonexp3], all the compliant [nonexp4] that will be added in the end
    else if (o.action === "Completed" && o.assessment !== "Compliant") {
      nonexp2.push(o);
    } else if (o.action === "Pending" && o.assessment !== "Compliant") {
      nonexp3.push(o);
    } else {
      nonexp4.push(o);
    }
  }

  //then should be all the nodate-Unassigned-Pending-'Everything but Compliant'
  for (let o of noDate) {
    if (
      o.user_id === "0" &&
      o.action === "Pending" &&
      o.assessment !== "Compliant"
    ) {
      nodue1.push(o);
    }
    //then the no due date-'No matter the assign status'-Comlpleted-'Everything but Compliant'
    //what is left of the no due date: assigned-pending-all [nodue3], all the compliant [nodue4] that will be added in the end
    else if (o.action === "Completed" && o.assessment !== "Compliant") {
      nodue2.push(o);
    } else if (o.action === "Pending" && o.assessment !== "Compliant") {
      nodue3.push(o);
    } else {
      nodue4.push(o);
    }
  }

  console.debug("SORTER all", {
    exp1,
    exp2,
    exp3,
    exp4,
    nonexp1,
    nonexp2,
    nonexp3,
    nonexp4,
    nodue1,
    nodue2,
    nodue3,
    nodue4
  });

  const sortedObligations = exp1.concat(
    exp2,
    nonexp1,
    nonexp2,
    nodue1,
    nodue2,
    exp3,
    nonexp3,
    nodue3,
    exp4,
    nonexp4,
    nodue4
  );
  //after all should be the Compliant expired non expired no date in ascending due date order

  console.debug("SORTER sorted", sortedObligations);
  console.groupEnd(); //end of SORTER LOGS group

  return sortedObligations;
};

//...for Internal Obligations
export const sortAdditionalObligations = obligations => {
  const sortedObl = sortAssessorObligations(obligations) ?? [];
  const edited = [];
  const empty = [];
  sortedObl.forEach(obl => {
    obl.__v ? edited.push(obl) : empty.push(obl);
  });
  return edited.concat(empty);
};

//sorts array of objects by value property
export const sortOptions = options => {
  try {
    const sortedOptions = options.toSorted((a, b) => {
      if (a?.value < b?.value) {
        return -1;
      }
      if (a?.value > b?.value) {
        return 1;
      }
      return 0;
    });
    return sortedOptions;
  } catch (err) {
    console.log("Couldn't sort options because of error: ", err);
    return options;
  }
};

export const sortObligationsBy = (
  obligations,
  type = "main",
  by = "law_title",
  order = "asc"
) => {


  if (!["main", "internal"].includes(type)) {
    console.error("Invalid 'type' arguement in sortObligationsBy");
    return obligations;
  }
  if (!["", "asc", "desc"].includes(order)) {
    console.error("Invalid 'order' arguement in sortObligationsBy");
    return obligations;
  }
  if (type === "main" && !["", "law_title", "article", "paragraph", "code", "mainCategory"].includes(by)) {
    console.error("Invalid 'by' arguement in sortMainObligationsBy");
    return obligations;
  }
  if (type === "internal" && !["", "mainCategory", "code"].includes(by)) {
    console.error("Invalid 'by' arguement in sortObligationsBy");
    return obligations;
  }

  if (!by || !order) return obligations;

  obligations?.sort((firstItem, secondItem) => {
    const a = order === "asc" ? firstItem : secondItem;
    const b = order === "asc" ? secondItem : firstItem;

    if (a?.[by]?.toUpperCase() < b?.[by]?.toUpperCase()) {
      return -1;
    }
    if (a?.[by]?.toUpperCase() > b?.[by]?.toUpperCase()) {
      return 1;
    }
    return 0;
  });

  return obligations;
};